<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useGarageStore } from "@/stores/garage.js";

export default {
  setup() {
    // I18n
    const { t } = useI18n();
    const translationPrefix = ref('modal.design_info');

    // Stores
    const modalStore = useModalStore();
    const garageStore = useGarageStore();

    // Variables
    const isLoading = ref(true);

    onMounted(async () => {});

    return {
      t,
      translationPrefix,
      modalStore,
      garageStore,
      isLoading,
    }
  },
};
</script>

<template>
  <div class="flex flex-col space-y-4 w-full px-8 py-4">
    <div class="w-full">
      <p class="font-semibold text-lg modal-header">{{ t(`${translationPrefix}.modal_body`) }}</p>
      <p class="text-md text-gray-600">{{ t(`${translationPrefix}.modal_body_text`) }}</p>
    </div>
      <div class="container mt-2">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-2 gap-y-2">
          <div class="flex flex-col px-0 sm:px-2 space-y-2">
            <div class="w-full">
              <label for="exterior" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.exterior_label`) }}</label>
              <input type="text" id="exterior" name="exterior" v-model="modalStore.newVehicle.specifications.exterior" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.exterior_placeholder`)">
            </div>
            <div class="w-full">
              <label for="oem_exterior" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.exterior_oem_label`) }}</label>
              <input type="text" id="oem_exterior" name="oem_exterior" v-model="modalStore.newVehicle.specifications.oem_exterior" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.exterior_oem_placeholder`)">
            </div>
            <div class="w-full">
              <label for="oem_exterior_code" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.exterior_order_code_label`) }}</label>
              <input type="text" id="oem_exterior_code" name="oem_exterior_code" v-model="modalStore.newVehicle.specifications.oem_exterior_code" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.exterior_order_code_placeholder`)">
            </div>
          </div>
          <div class="flex flex-col px-0 sm:px-2 space-y-2">
            <div class="w-full">
              <label for="interior" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.interior_label`) }}</label>
              <input type="text" id="interior" name="interior" v-model="modalStore.newVehicle.specifications.interior" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.interior_placeholder`)">
            </div>
            <div class="w-full">
              <label for="oem_interior" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.interior_oem_label`) }}</label>
              <input type="text" id="oem_interior" name="oem_interior" v-model="modalStore.newVehicle.specifications.oem_interior" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.interior_oem_placeholder`)">
            </div>
            <div class="w-full">
              <label for="oem_interior_code" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.interior_order_code_label`) }}</label>
              <input type="text" id="oem_interior_code" name="oem_interior_code" v-model="modalStore.newVehicle.specifications.oem_interior_code" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.interior_order_code_placeholder`)">
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/garage';
</style>
